import { useForm, Controller } from 'react-hook-form';
import {
  Box,
  TextField,
  Button,
  Typography,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

const targets = [
  { id: 1, name: 'Page' },
  { id: 2, name: 'Functionality' },
];

const defaultValues = {
  name: '',
  description: '',
  url: '',
  target: 0,
  access: 'Disable',
  childIds: [],
};

const ALLOWED_PATTERN = /^[\p{L}\p{N}]/u;

const PermissionForm = ({ onCreate, permission }) => {
  const { t } = useTranslation('translations');

  const {
    control,
    handleSubmit,
    register,
    formState: { errors },
  } = useForm({
    defaultValues,
    mode: 'onChange',
  });

  const onSubmit = (data) => {
    const newData = {
      ...data,
      childIds: [],
    };

    onCreate(newData);
    reset(defaultValues);
  };

  const textRules = {
    validate: (value) => {
      const v = (value ?? '').trim();
      if (!v) return t('EmptyInput') || 'This field cannot be empty';
      if (!ALLOWED_PATTERN.test(v)) {
        return (
          t('SpecialCharactersNotAllowed') ||
          "Only letters, numbers, spaces and - . , _ ( ) / & : + ' are allowed"
        );
      }
      return true;
    },
    setValueAs: (v) => (typeof v === 'string' ? v.trimStart() : v),
  };

  return (
    <Box sx={{ maxWidth: 800, mx: 'auto', mt: 4 }}>
      <Typography variant="h6">{t('Permission')}</Typography>
      <form onSubmit={handleSubmit(onSubmit)}>
        <TextField
          fullWidth
          label={t('Name')}
          error={!!errors.name}
          helperText={errors.name?.message}
          {...register('name', textRules)}
          sx={{ mt: 2 }}
        />
        <TextField
          fullWidth
          label="Description"
          error={!!errors.description}
          helperText={errors.description?.message}
          {...register('description', textRules)}
          sx={{ mt: 2 }}
        />
        <TextField fullWidth label="URL" {...register('url')} sx={{ mt: 2 }} />
        <FormControl fullWidth sx={{ mt: 2 }}>
          <InputLabel>Target</InputLabel>
          <Controller
            name="target"
            control={control}
            render={({ field }) => {
              return (
                <Select {...field} label="Target">
                  {!permission ? (
                    <MenuItem value={0}>Module</MenuItem>
                  ) : (
                    targets.map((t) => (
                      <MenuItem key={t.id} value={t.id}>
                        {t.name}
                      </MenuItem>
                    ))
                  )}
                </Select>
              );
            }}
          />
        </FormControl>
        <FormControl fullWidth sx={{ mt: 2 }}>
          <InputLabel>Access</InputLabel>
          <Controller
            name="access"
            control={control}
            render={({ field }) => (
              <Select {...field} label="Access" disabled>
                <MenuItem value="Disable">Disable</MenuItem>
              </Select>
            )}
          />
        </FormControl>
        <Button variant="contained" color="primary" type="submit" sx={{ mt: 3 }}>
          {t('Create')}
        </Button>
      </form>
    </Box>
  );
};

export default PermissionForm;
